var card_content_default = {
  "content": "oHdBy",
  "textStart": "K8i-M",
  "contentText": "_7zJZr",
  "subtitle": "U1PYI",
  "pricing": "zn-Lr",
  "titlePriceContainer": "b5gry",
  "textCenter": "DKdRI",
  "textEnd": "QfgQh",
  "titlePriceSideBySide": "CV1Om",
  "titlePriceStacked": "plOvQ",
  "title": "_0bTfw",
  "price": "xxKz0",
  "priceDiscounted": "wCo9R",
  "priceOriginal": "uhy8S",
  "priceStrikethrough": "zziK3",
  "ribbon": "IPZMX",
  "button": "-HwRp",
  "button_disabled": "Ne0TK",
  "buttonText": "_5PNvg",
  "framelessContent": "b95bD",
  "framelessImageTop": "izCoJ",
  "framelessImageStart": "NGRVm",
  "framelessImageEnd": "PSTI4"
};
export {
  card_content_default as default
};
//# sourceMappingURL=card-content-scss.js.map
